import { render, staticRenderFns } from "./OnboardHRM.vue?vue&type=template&id=9d26feda&"
import script from "./OnboardHRM.vue?vue&type=script&lang=js&"
export * from "./OnboardHRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports